"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpDefPlaceChooser = void 0;
const useOpDefinitionFindById_1 = __importDefault(require("@opsbase/react-gql-hooks/opdefinition/useOpDefinitionFindById"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const react_1 = __importDefault(require("react"));
const ItemChooser_1 = __importDefault(require("../ItemChooser"));
const PlaceChooser_1 = __importDefault(require("../PlaceChooser"));
function OpDefPlaceChooser(props) {
    const { opDefinition, allSelectable = false, multi = false, required = true, value, placesList, allSelected, onChange, disabled = false, onSelectAll, } = props;
    const usingId = typeof opDefinition === 'string';
    const { loading, data: loadedOpDef } = (0, useOpDefinitionFindById_1.default)({
        variables: { id: opDefinition },
        skip: !usingId || !opDefinition,
    });
    const opDef = usingId ? loadedOpDef : opDefinition;
    const isLoading = usingId && loading;
    const placesSelectedByTag = !!(opDef === null || opDef === void 0 ? void 0 : opDef.placesSelectedByTag);
    return (react_1.default.createElement(Spinner_1.default, { busy: isLoading },
        !isLoading && placesSelectedByTag && (react_1.default.createElement(PlaceChooser_1.default, { multi: multi, allSelectable: allSelectable, required: required, filters: { tag: opDef === null || opDef === void 0 ? void 0 : opDef.placeTags }, disabled: disabled, value: value, onChange: onChange, allSelected: allSelected, selectLabel: lib_i18n_1.default.t('select-place'), allSelectedLabel: lib_i18n_1.default.t('all-permitted-places'), onSelectAll: onSelectAll })),
        !isLoading && !placesSelectedByTag && (react_1.default.createElement(ItemChooser_1.default, { multi: multi, allSelectable: allSelectable, required: required, disabled: disabled, items: placesList, value: value, onChange: onChange, label: lib_i18n_1.default.t('select-place'), allSelected: allSelected, allSelectedLabel: lib_i18n_1.default.t('all-permitted-places'), onSelectAll: onSelectAll }))));
}
exports.OpDefPlaceChooser = OpDefPlaceChooser;
exports.default = OpDefPlaceChooser;
